module.exports = __webpack_public_path__ + "static/media/clue0304.69812a0c.jpg";